import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'escapeHtml',
    standalone: false
})
export class EscapeHtmlPipe implements PipeTransform {
  private readonly htmlEscapes: { [key: string]: string } = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#039;',
    '/': '&#x2F;',
  };

  transform(value: string): string {
    if (!value) return '';

    return value.replace(/[&<>"'/]/g, (match) => this.htmlEscapes[match]);
  }
}
